export default "__VITE_ASSET__BIY_6fT1__"